/**
 * Update date: 2024-03-18
 * Screen 2044.B
 */
import { NotFoundPage } from 'app/components/NotFoundPage';
import useAxios from 'axios-hooks';
import LoadPanel from 'app/components/LoadPanel';
import React, { createContext, useContext, useState } from 'react';
import useLocalStorage from 'hooks/useLocalStorage';

const List = React.lazy(() => import('./List'));
const CreateForm = React.lazy(() => import('./CreateForm'));
const ViewForm = React.lazy(() => import('./ViewForm'));
const ViewInvoice = React.lazy(() => import('./ViewInvoice'));

/**
 * create context
 */
const ModuleContext = createContext({});
ModuleContext.displayName = 'M2044_B_Context';
export const useModuleContext = () => {
  return useContext(ModuleContext);
};

const M2044_B = () => {
  const [data, setData] = useState([]);
  const [modeView, setModeView] = useState({
    type: 'list',
    data: null,
  });
  const [dataLocal, setDataLocal] = useLocalStorage('2044.B_dataList', {});

  const [formSearchData, setFormSearchData] = useState<any>({
    fromDate: new Date(),
    toDate: new Date(),
    dataList: {
      deliveryCompany: [],
    },
    deliveryCompany: '',
  });
  const [infoData, setInfoData] = useState<any>({
    dataList: {
      deliveryCompany: [],
    },
    deliveryCompany: '',
  });
  const [{ loading: loadingfetchData }, refetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  const value: any = {
    data,
    setData,
    modeView,
    setModeView,
    dataLocal,
    setDataLocal,
    refetchData,
    formSearchData,
    setFormSearchData,
    infoData,
    setInfoData,
  };

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List />;
      case 'create':
        return <CreateForm />;
      case 'viewForm':
        return <ViewForm />;
      case 'result':
        return <ViewInvoice />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <ModuleContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <LoadPanel visible={loadingfetchData} />
        {renderContent()}
      </React.Suspense>
    </ModuleContext.Provider>
  );
};

export default M2044_B;
